/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import logo from '../../assets/logos/fitinsur-logo-black.svg';

import { Wrapper, Container, Logo, Website } from './styles';

export default function Footer() {
  return (
    <Wrapper>
      <Container>
        <Website>www.fitinsur.com.br</Website>
        <Logo src={logo} />
      </Container>
    </Wrapper>
  );
}
